import script from "./confirmAction.vue?vue&type=script&setup=true&lang=js"
export * from "./confirmAction.vue?vue&type=script&setup=true&lang=js"

import "./confirmAction.vue?vue&type=style&index=0&id=ec7f1394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec7f1394"]])

export default __exports__